import { Button, Link, styled, SvgIcon, Typography } from '@ori-ui/mui';

import { TOP_AREA_BANNER_HEIGHT } from '../TopAreaBanner/constants';

export const BackArrow = styled(SvgIcon)(({ theme }) => ({
  cursor: 'pointer',
  position: 'absolute',
  left: theme.spacing(3),
  top: theme.spacing(3),
}));

export const OrderContent = styled('div')(({ theme }) => ({
  textAlign: 'center',
  margin: '0 auto',
  color: theme.palette.common.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  span: {
    lineHeight: theme.typography.pxToRem(TOP_AREA_BANNER_HEIGHT),
    textTransform: 'uppercase',
    fontSize: theme.typography.pxToRem(10),
  },

  svg: {
    height: theme.typography.pxToRem(20),
  },

  'svg:first-of-type': {
    marginRight: theme.spacing(1),
  },
  'svg:last-of-type': {
    marginLeft: theme.spacing(1),
  },
}));

export const Username = styled(Typography)(({ theme }) => ({
  textDecoration: 'underline',
  color: theme.palette.common.white,
  marginLeft: theme.spacing(1),
  cursor: 'pointer',
}));

export const PopupContentGroup = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginTop: theme.spacing(3),
}));

export const PopupButton = styled(Button)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

export const PopupLink = styled(Link)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  textAlign: 'center',
  color: theme.palette.common.black,
}));
